/**
 * @Description
 */

import { Button, Modal } from 'antd';
import { FC } from 'react';

interface ConfirmExportProps {
  open: boolean;
  setOpen: Function;
  handleNo: Function;
  handleYes: Function;
}

const ConfirmExport: FC<ConfirmExportProps> = ({
  open,
  setOpen,
  handleNo,
  handleYes,
}) => {

  return (
    <Modal
      title='提示'
      open={open}
      maskClosable={false}
      onCancel={() => setOpen(false)}
      footer={<div>
        <Button
          onClick={() => {
            setOpen(false);
            handleNo();
          }}>不导出</Button>
        <Button
          type='primary'
          onClick={() => {
            setOpen(false);
            handleYes();
          }}>导出</Button>
      </div>}
    >
      <p>是否导出「审批意见」？</p>
    </Modal>
  );
};

export default ConfirmExport;
